import axios from 'axios';

export const getCategory = async () => {
    try {
        const url = `${process.env.REACT_APP_API_BASE_URL}/categories`;
        const response = await axios.get(
            url,
            {
                params: {
                    statut: 1
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des catégories :', error);
        throw error;
    }
};